import { PackageResponse } from './../../api/response/AuthorizeEMarketplace';
import { AuthorizeEmarketplaceClient } from '../../api/AuthorizeEMarketplaceClient';
export class SubscriptionPlanHelper {
  public static getDefaultSubscriptionPlans = (companyID: number, roleID: number = 2) => {
    if (!companyID) return AuthorizeEmarketplaceClient.getSupplierPackageList().toPromise();
    return AuthorizeEmarketplaceClient.getPackageList(companyID, roleID).toPromise();
  };

  public static getSubscriptionPlanByID = async (
    companyID: number,
    planID: number,
    roleID: number = 2,
  ) => {
    const packages: PackageResponse[] = await SubscriptionPlanHelper.getDefaultSubscriptionPlans(
      companyID,
      roleID,
    );
    return packages.find((sp) => sp.subscriptionPlanID === planID);
  };
}

export const FREE_TRIAL_PLAN_ID = 1;
